import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiService} from "../api.service";
import {Country, ICity, IState} from "../../models/geography.model";

@Injectable({
  providedIn: "root",
})
export class GeographyControllerService {
  private readonly _resourceUrl: string = "/geography";

  constructor(private apiService: ApiService) {}

  getAllCountries(): Observable<Country[]> {
    return this.apiService.get(`${this._resourceUrl}/countries`);
  }

  getStatesByCountry(countryId: string): Observable<IState[]> {
    return this.apiService.get(`${this._resourceUrl}/states`, { countryId });
  }

  getCitiesByState(stateId: string): Observable<ICity[]> {
    return this.apiService.get(`${this._resourceUrl}/cities`, { stateId });
  }
}
